(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HotelEngineSearch',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		Adzuki.GooglePlaces($form.find('.google-places'));

		// This will stop the checkout date to change automatically
		$('#hotelenginesearch-checkin').on('dp.change', function populateDropoff(e) {
			var checkout_date = '';

			if ($('#hotelenginesearch-checkout').val() !== '') {
				checkout_date = Date.parse($('#hotelenginesearch-checkout').val());
			}

			if (
				e.date
				&& (
					checkout_date === '' ||
					checkout_date <= e.date
				)
			) {
				$('#hotelenginesearch-checkout').data('DateTimePicker').date(e.date.add(1, 'days'));
			}
		});

		// only show adult/children fields for the number of rooms selected
		$('#hotelenginesearch-num_rooms').on('change', function roomsChange(e) {
			var $self   = $(this),
			    room_ct = $self.val(),
			    i       = 1;

			// hide all rooms
			$('.room').addClass('hidden');

			// show # of rooms
			for (i; i <= room_ct; i++) {
				$('#room-' + i).removeClass('hidden');
			}
		});

		// only show age dropdowns for the number of children selected for the room
		$('.children-per-room').on('change', function childrenChange(e) {
			var $self       = $(this),
			    child_ct    = $self.val(),
			    $room       = $self.closest('.room'),
			    $child_ages = $room.find('.children-age'),
			    i           = 1;

			$child_ages.each(function showAges() {

				$(this).addClass('hidden');

				if (i <= child_ct) {
					$(this).removeClass('hidden');
				}

				i++;
			});
		});
	};
}(jQuery, window.Adzuki || {}));
